<script setup>
/*
 * Broedtekst.
 *
 * HTML og ikke Markdown — huset skriver allerede raa HTML i artiklerne.
 * Saneringen sker i sanitizeHtml, som er SSR-sikker i den forstand at den
 * ikke vaelter; men bemaerk at den returnerer HTML'en UROERT under SSR.
 * Det er forsvarligt saa laenge alt indhold skrives af os. Bliver blokke
 * nogensinde brugerskabte, skal saneringen flyttes til serveren.
 */
import { sanitizeHtml } from '@/Utils/sanitize';
import { computed } from 'vue';

const props = defineProps({
    data: { type: Object, required: true },
});

const html = computed(() => sanitizeHtml(props.data.tekst || ''));
</script>

<template>
    <div class="blok-tekst" v-html="html"></div>
</template>

<style scoped>
.blok-tekst :deep(h2) { font-size: 1.4rem; margin-top: 1.5rem; }
.blok-tekst :deep(h3) { font-size: 1.15rem; margin-top: 1.25rem; }
.blok-tekst :deep(p) { line-height: 1.65; }
.blok-tekst :deep(img) { max-width: 100%; height: auto; }
.blok-tekst :deep(table) { width: 100%; }
</style>
